import {observer} from 'mobx-react';
import {Input} from 'semantic-ui-react';
import {FC} from 'react';

import ActiveEptStore from '../store/ActiveEptStore';

type SearchPropsType = {
  activeEpt: ActiveEptStore;
};

const Search: FC<SearchPropsType> = ({activeEpt}) => {
  return (
    <Input
      fluid
      className='ept-search'
      icon={!activeEpt.searchString ? null : {name: 'close', link: true, onClick: () => activeEpt.searchOnChange('')}}
      placeholder='Search...'
      value={activeEpt.searchString}
      onChange={(_, {value}) => activeEpt.searchOnChange(value)}
    />
  );
};

export default observer(Search);
